<template>
    <el-drawer
        class="drawer"
        :title="detailData.title"
        :visible.sync="detailParam.visible"
        size="520px"
        :close-on-press-escape="false"
        :wrapperClosable="false"
    >
        <div class="drawer-wrapper">
            <div class="drawer-main" v-loading="detailData.loading.main">
                <div class="drawer-body">
                    <el-form :model="detailData" ref="detailData" size="small">
                        <el-form-item>
                            <el-radio-group v-model="detailData.model.rule">
                                <el-radio-button :label="1">自己</el-radio-button>
                                <el-radio-button :label="2">他人</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <template v-if="detailData.model.rule !== 1">
                            <el-form-item
                                prop="row.visit_user_id"
                                :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                            >
                                <el-select v-model="detailData.row.visit_user_id">
                                    <el-option
                                        :key="item.user_id"
                                        :label="item.name"
                                        :value="item.id"
                                        v-for="item in userData.list"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                        <el-form-item
                            label="时间："
                            prop="row.visit_remind_at"
                            :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                        >
                            <el-date-picker
                                v-model="detailData.row.visit_remind_at"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                            ></el-date-picker>
                        </el-form-item>
                        <el-form-item
                            label="内容："
                            prop="row.visit_remind_memo"
                            :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
                        >
                            <el-input
                                type="textarea"
                                v-model="detailData.row.visit_remind_memo"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                size="small"
                                :loading="detailData.loading.submit"
                                @click="SubmitlDetail('detailData')"
                                >保 存</el-button
                            >
                            <el-button size="small" @click="detailParam.visible = false"
                                >取 消</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import { UserData } from '@/plugin/User'
export default {
    inject: ['reload'],
    props: ['detailParam'],
    mixins: [UserData],
    data() {
        return {
            userData: {
                list: [],
                pages: {
                    page: 1,
                    pagesize: 9999
                }
            },
            detailData: {
                title: '回访任务',
                loading: {
                    main: false,
                    submit: false
                },
                model: {
                    rule: 1
                },
                row: {
                    visit_user_id: null,
                    visit_remind_at: null,
                    visit_remind_memo: null
                }
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.GetUser()
        })
    },
    mounted() {
        this.$nextTick(() => {})
    },
    watch: {
        'detailData.model.rule'() {
            this.detailData.row.visit_user_id = null
        }
    },
    methods: {
        // 员工列表
        GetUser() {
            this.detailData.loading.main = true
            this.GetUserData({
                data: {
                    order: 'asc',
                    ...this.userData.pages
                }
            }).then(res => {
                this.detailData.loading.main = false
                this.userData.list = res.list
            })
        },
        SubmitlDetail(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.detailData.loading.submit = true
                    this.$request({
                        url: '/api/v1/customer_visit_add',
                        params: {
                            ...this.detailParam.row,
                            ...this.detailData.row
                        }
                    }).then(res => {
                        this.detailData.loading.submit = false
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.detailParam.visible = false
                            this.$parent.GetTask()
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
</style>
